import { ISearchForm } from "../redux/searchForm";

export const isValidMetaSearchQuery = (searchQuery: ISearchForm) => {
  const {
    fareId,
    hmac,
    utm_medium,
    utm_source,
    totalPrice,
    adultPrice,
    childPrice,
    infantPrice,
    timestampInSeconds,
  } = searchQuery;

  if (
    fareId === null ||
    hmac === null ||
    utm_medium === null ||
    utm_source === null ||
    utm_source.includes("=") ||
    totalPrice === null ||
    adultPrice === null ||
    childPrice === null ||
    infantPrice === null ||
    timestampInSeconds === null
  ) {
    return false;
  }

  return true;
};

export const getMetaSearchQuery = (searchQuery: ISearchForm) => {
  return {
    metaPartnerCode: searchQuery.utm_source as string,
    fareId: searchQuery.fareId as string,
    hmac: encodeURIComponent(searchQuery.hmac as string),
    utmCampaign: searchQuery.utm_campaign as string,
    utmMedium: searchQuery.utm_medium as string,
    utmContent: searchQuery.utm_content as string,
    mktPortal: searchQuery.mktPortal as string,
    totalPrice: searchQuery.totalPrice as number,
    adultPrice: searchQuery.adultPrice as number,
    childPrice: searchQuery.childPrice as number,
    infantPrice: searchQuery.infantPrice as number,
    timestampInSeconds: searchQuery.timestampInSeconds as number,
    clickId: searchQuery.clickId || (searchQuery.utm_source as string),
    gclsrc: searchQuery.gclsrc as string,
  };
};

export const isOutdatedMetaSearchQuery = (searchQuery: ISearchForm) => {
  return new Date(searchQuery.metaStorageTimeout) < new Date();
};
